module.exports = __webpack_public_path__ + "img/thumbnail-slide-calyrafit.3b28b4b3.webp";